/* global module */

const UNITS_PER_M = 10.0;

module.exports = {
	mm: n => (n * UNITS_PER_M) / 1000,
	cm: n => (n * UNITS_PER_M) / 100,
	m: n => n * UNITS_PER_M,

	mmReverse: n => (n * 1000) / UNITS_PER_M,
};
